import * as actionTypes from '../redux/actionTypes';

import React, { useEffect, useState } from 'react';

import ContactInfo from './ContactInfo';
import DashboardBackground from './new-dashboard/dashboard-background/DashboardBackground';
import DashboardVanDetails from './new-dashboard/van-details/DashboardVanDetails';
import DownloadApp from './download-app/DownloadApp';
import FuelCard from './FuelCard';
import ImpactDataContainer from '../vanpool-vehicle/impact-data/ImpactDataContainer';
import InviteRiderPopup from '../shared/popup/InviteRiderPopup';
import Loading from '../shared/loading/Loading';
import Maintenance from '../vanpool-vehicle/Maintenance';
import NewRegisteredUser from './registered-user/new-registered-user/NewRegisteredUser';
import { PERMISSION_ACCOUNT_DASHBOARD_ADMIN, PERMISSION_VAN_STARTING_IN_FUTURE, PERMISSION_TRIP_RECORDING, PERMISSION_VANPOOL_TRIP_RECORDING, SUBSCRIPTION_TRIP_RECORDER, PERMISSION_DRIVER, PERMISSION_COORDINATOR, PERMISSION_APPROVED_DRIVER, PERMISSION_TRADITIONAL_APPROVED_DRIVER_TRIPRECORDER } from '../shared/permissions/permissions';
import { Redirect } from 'react-router/cjs/react-router.min';
import { RestrictFrom, isAllowed } from '../shared/permissions/RestrictTo';
import RiderTripRecordingBanner from './RiderTripRecordingBanner';
import RouteMap from '../map/RouteMap';
import StopTracker from './StopTracker';
import TripRecordingBanner from './TripRecordingBanner';
import { connect } from 'react-redux';
import dateUtility from '../shared/dateUtility';
import {getNextRoutePoint } from '../shared/route-service';
import NotificationBanner from './notificationBanners/NotificationBanners';
import analyticsService from '../shared/analytics/analytics-service';
import { getDateForDashboard } from '../shared/helpers/dateHelpers';
import EmployerIdPopup from './Employer-id/EmployerIdPopup';
import EmployerIdThankyouPopup from './Employer-id/EmployerIdThankyouPopup';

function NewDashboard(props) {
  const [navigateTo, updateNavigateTo] = useState('');
  const [showRoute, updateShowRoute] = useState('outboundRoutePoints');
  const [showMap, updateShowMap] = useState(true);
  const [inviting, upateInviting] = useState(false);
  const [isNewSubscription, updateIsNewSubscription] = useState(false);
  const [pendingChangeStartDate, updatePendingChangeStartDate] = useState('');
  const [predeliveryStartDate, updatePredeliveryStartDate] = useState('');
  const [fname, updateFname] = useState('');
  const [isInVanpool, updateIsInVanpool] = useState(false);
  const [nextStop, updateNextStop] = useState(false);
  const [stop, updateStop] = useState(false);
  const [loading, updateLoading] = useState(true);
  const [vanpoolDetails, updateVanpoolDetails] = useState({});
  const [isVanForming, updateIsVanForming] = useState(false);
  const [isDriver, updateIsDriver] = useState(false);
  const [userCommuteDays, updateUserCommuteDays] = useState();
  const [showEmployerIdPopup, UpdateShowEmployerIdPopup] = useState(false);
  const [showEmployerThankyou, updateShowEmployerThankyou] = useState(false);
  const [startEmployerLoader, updateStartEmployerLoader] = useState(false);

  useEffect(() => {
    props.setDirections([]);
    if (props.refreshDashboard) {
      updateLoading(true);
      props.updateLoading(true);
      props.fullRefresh();
    } else if(props.refreshDashboardAfterContract) {
      updateLoading(true);
      props.updateLoading(true);
      props.fullRefreshAfterContract();
    } else if (!props.isDashboardLoaded || !props.profileLoaded) {
      updateLoading(true);
      props.updateLoading(true);
      props.init(props.profileLoaded);
    }
    sessionStorage.removeItem('trip-banner-analytics');
  }, []);

  useEffect(() => {
    if (props.isDashboardLoaded && props.profileLoaded) {
      updateLoading(false);
      props.updateLoading(false);
    } else {
      updateLoading(true);
      props.updateLoading(true);
    }
    if(props.isDashboardLoaded && props.profileLoaded && props.showEmployerIdPopup){
      if (props.employeeInfo && props.employeeInfo.isEmployeeIdRequired && !props.employeeInfo.employeeId) {
        UpdateShowEmployerIdPopup(true);
        props.preventHeaderEvents(true);
      } else {
        props.updateEmployerIdPopup(false);
      }
    }
  }, [props.isDashboardLoaded, props.profileLoaded, props.showEmployerIdPopup]);

  useEffect(() => {
    if (props.refreshDashboard === false) {
      updateLoading(false);
      props.updateLoading(false);
    }
  }, [props.refreshDashboard])

  useEffect(() => {
    if (props.isTraditionalLead) {
      analyticsService.getPageName({
        "pagename": "ride together/thank you",
        "process": "ride together"
      })
      props.history.push({pathname: '/JoinCommute/vanpool-details/traditional-thankyou',state: {rideTogether:true}});
    }
  }, [props.isTraditionalLead])
  

  useEffect(() => {
    if (props.dashboard) {
      updateVanpoolDetails(props.dashboard.vanpoolDetails);
      if ( props.vanpoolStatus && (props.vanpoolStatus === 'A' || props.vanpoolStatus === 'P')) {
        updateShowMap(false);
        updateIsInVanpool(true);
        if(props?.dashboard?.vanpoolDetails?.expectedCommuteStartDate){
          const startDay = getDateForDashboard(props.dashboard.vanpoolDetails.expectedCommuteStartDate);
          updatePredeliveryStartDate(startDay);
          updateIsVanForming(false);
        } else {
          updateIsVanForming(true);
        }
      }
      else if (props.profile.subscriptionAPIInfo && props.profile.subscriptionAPIInfo.package === null && props.profile.subscriptionAPIInfo.pendingChange !== null) {
        updateIsNewSubscription(true);
        updateShowMap(false);
        const startDay = dateUtility.parseDateAsMonthDayYearFromGMTShort(props.profile.subscriptionAPIInfo.pendingChange.startDate);
        updatePendingChangeStartDate(startDay);
        updateIsInVanpool(true);
      }
      else if (!props.dashboard.vanpoolDetails || !props.dashboard.vanpoolDetails.vanpoolId || props.dashboard.vanpoolDetails.vanpoolId === null) {
        updateIsInVanpool(false);
        updateShowMap(false);
      }
      else if (props.dashboard.vanpoolDetails && props.dashboard.vanpoolDetails.vanpoolId && props.dashboard.vanpoolDetails.vanpoolId !== null) {
        updateIsInVanpool(true);
        updateShowMap(true);
      }
      else {
        updateShowMap(true);
      }
    }
    if (props.profile) {
      updateIsDriver(props.profile.isDriver);
      updateUserCommuteDays(props.profile.vanpool && props.profile.vanpool.smallCommuteDays);
    }
  }, [props.dashboard, props.profile, props.vanpoolRoute])

  useEffect(() => {
    if (props.vanpoolRoute) {
      const { route, index } = getNextRoutePoint(props.vanpoolRoute);
      updateShowRoute(route);
      updateNextStop(index);
      props.setDirections(props.vanpoolRoute[route]);
    }
  }, [props.vanpoolRoute])

  useEffect(() => {
    <Redirect push to={navigateTo} />;
  }, [navigateTo])

  useEffect(() => {
    const stopTemp = nextStop > -1 ? props.vanpoolRoute[showRoute][nextStop] : {};
    updateStop(stopTemp);
  }, [nextStop])

  useEffect(() => {
    if (props.profile) {
      updateFname(props.profile.fname);
    }
  }, [props.profile])

  useEffect(() => {
    if(isVanForming === true) {
      analyticsService.getPageName({
        "pagename": "dashboard/vanpool forming"
      })
    } else if(pendingChangeStartDate) {
      analyticsService.getPageName({
        "pagename": "dashboard/vanpool starts soon"
      })
    } else if(!isInVanpool && !isVanForming && !pendingChangeStartDate && !props.vanpoolId && !props.isRecentLeadSubmitted && !props.isTraditionalLead) {
      analyticsService.getPageName({
        "pagename": "dashboard/not part of vanpool"
      });
    }
  }, [isVanForming, pendingChangeStartDate, isInVanpool]);

  useEffect(() => {
    if(props.isRecentLeadSubmitted){
        analyticsService.getPageName({
            "pagename": "dashboard/vanpool request received"
          })
      }
  },[props.isRecentLeadSubmitted])

  useEffect(() => {
    if(props.profilePermissionCompleted && !props.dashboard.tripRecordingStatusLoaded){
        props.callTripStatus();
        // props.resetProfilePermission(false); // Remove this - it's causing the issue
    }
  },[props.profilePermissionCompleted]);

  useEffect(() => {
    if(props.vanpoolId){
      if(props.isSubscriptionUser){
        analyticsService.getPageName({"pagename": "dashboard/subscription vanpool"});
      }else{
        analyticsService.getPageName({"pagename": "dashboard/traditional vanpool"});
      }
    }
  },[props.isSubscriptionUser])

  function hasAddressData(address) {
   return Object.values(address).some(
      v =>
        (typeof v === "string" && v.trim() !== "") ||
        (typeof v === "number" && !Number.isNaN(v))
    );
  }

  function saveEmployerId(data, addedAddress, addedPhone) {
    if(data){
      const saveObject = {
        homeAddress: addedAddress ? data.homeAddress : props.profile.homeAddress,
        mailingAddress : addedAddress && hasAddressData(data.mailingAddress) ? data.mailingAddress : hasAddressData(props.profile.mailingAddress) ?  props.profile.mailingAddress : props.profile.homeAddress,
        phone: addedPhone ? data.phone : props.profile.phone,
        secondPhone: props.profile.secondPhone,
        employeeId: data.employeeId
      }
      updateStartEmployerLoader(true);
      props.updateEmployerId(saveObject, true);
    }
  }
  function closeThankyou() {
    props.callUpdatedProfileAPI();
    updateShowEmployerThankyou(false);
  }

  useEffect(() => {
    if(props.employeeIdUpdated){
      updateStartEmployerLoader(false);
      UpdateShowEmployerIdPopup(false);
      props.preventHeaderEvents(false);
      updateShowEmployerThankyou(true);
      props.updateEmployerIdSuccess(false);
      analyticsService.analyticsProcessEvent({
        "event": "modal_click_generic",
        "context": {
          "event_action": "submit",
          "event_detail": {
            "modal": "dashboard/mandatory eid modal"
            }
        }
      });
    }
    if(props.employeeIdUpdatedFailed){
      updateStartEmployerLoader(false);
      props.updateEmployerIdFailure(false);
    }
  },[props.employeeIdUpdated, props.employeeIdUpdatedFailed]);

  const predeliveryText = "If a representative hasn't touched base with you yet, rest assured, one will reach out soon to keep you posted on the vanpool's progress.";
  const recentLeadSubmitted = "A representative will contact you within 24 business hours to get your commute set up!";

  return (
    loading ?
      <Loading isLoading={loading} />
      :
      <div className="dashboard">
        {showMap ?
          <div>
            <StopTracker
              stop={stop}
              index={nextStop}
              totalStops={(showRoute && props.vanpoolRoute && props.vanpoolRoute[showRoute] && props.vanpoolRoute[showRoute].length) || 0}
              isDriver={isDriver}
              userCommuteDays={userCommuteDays}
              profile={props.profile}
              vanpoolRoute={props.vanpoolRoute}
              updateLoading={updateLoading}
              isSubscriptionUser={props.isSubscriptionUser}
              isInVanpool={isInVanpool}
              userProfile={props.userProfile}
            />
            <div className="map-spacer" onClick={() => updateNavigateTo('/route')} role='group'>
              <RouteMap
                controls={false}
                isCustomMarkers={true}
                padding={
                  window.innerWidth > 768
                    ? { bottom: 125, top: -100, left: 0, right: 0 }
                    : null
                }
              />
            </div>
          </div>
          :
          <DashboardBackground name={fname} startDay={pendingChangeStartDate} predeliveryStartDate={predeliveryStartDate} isInVanpool={isInVanpool} isVanForming={isVanForming} isRecentLeadSubmitted={props.isRecentLeadSubmitted} />
        }
        <RestrictFrom roles={[PERMISSION_VAN_STARTING_IN_FUTURE]} required={false}>
          {isInVanpool && !isNewSubscription && !isVanForming && !predeliveryStartDate && <div className="trip-tools mobile-only" role='group'>
            <TripRecordingBanner />
            <RiderTripRecordingBanner />
          </div>}
        </RestrictFrom>
        <div className="bottom bottom-grid main-content">
          {isInVanpool ? <div className="left-side" role='group'>
            {!isNewSubscription && !isVanForming && !predeliveryStartDate && <div className="vanpool-details solid" role='group'>
              <div
                className="maintenance-container"
                onClick={() => {props.history.push('/vanpool');
                                  analyticsService.analyticsProcessEvent({
                                    "event": "banner interaction",
                                      "context": {
                                        "event_action": "click", 
                                        "banner_topic": "preventive maintenance"
                                      }
                                  })}}
              >
                <Maintenance
                  nextMaintenanceDate={
                    vanpoolDetails.nextScheduledMaintenanceDate
                  }
                  nextMaintenanceMileage={
                    vanpoolDetails.nextScheduledMaintenanceOdometer
                  }
                  lastMaintenanceDate={
                    vanpoolDetails.lastPreventativeMaintenanceOdometerDate
                  }
                  lastMaintenanceMileage={
                    vanpoolDetails.lastPreventativeMaintenanceOdometer
                  }
                />
              </div>
            </div>}
            <NotificationBanner history={props.history} />
            {
              isVanForming && <div className='predelivery-text'>{predeliveryText}</div>
            }
            <DashboardVanDetails profile={props.profile} vanpoolDetails={props.dashboard.vanpoolDetails} isVanForming={isVanForming} participantCount={props.vanpoolRoute.participantCount}/>
            {
              !isVanForming && !predeliveryStartDate &&
              <RestrictFrom
                roles={[PERMISSION_ACCOUNT_DASHBOARD_ADMIN]}
                required={false}
              >
                <ImpactDataContainer impactData={props.impactData} isNewSubscription={isNewSubscription} includeParking={false}  includeAccountDashboardInfo={false} onlyCurrent={true} />
              </RestrictFrom>
            }
            <div className="ipad-horizontal">
              <ContactInfo isInVanpool={isInVanpool} />
            </div>
          </div>
            :
            <div className="left-side" role='group'>
            {
              props.isRecentLeadSubmitted && <div className='recentLeadSubmitted-text'>{recentLeadSubmitted}</div>
            }
              <NewRegisteredUser isRecentLeadSubmitted={ props.isRecentLeadSubmitted} />
            </div>
          }
          <div className="right-side" role='group'>
            <DownloadApp  isRecentLeadSubmitted={ props.isRecentLeadSubmitted}/>
          </div>
          <InviteRiderPopup
            active={inviting}
            close={() => this.setState({ inviting: false })}
          />
        </div>
        {
          showEmployerIdPopup && <EmployerIdPopup profile={props.profile} employeeInfo={props.employeeInfo} saveEmployerId={(employeeId,addedAddress,addedPhone) => saveEmployerId(employeeId,addedAddress,addedPhone)} startEmployerLoader={startEmployerLoader} />
        }
        {
          showEmployerThankyou && <EmployerIdThankyouPopup closeThankyou={ () => closeThankyou()} />
        }
      </div>
  );
}

function mapStateToProps(state) {
  return {
    dashboard: state.dashboard,
    isDashboardLoaded: state.dashboard.isDashboardLoaded,
    rosterLoaded: state.roster.loaded,
    vanpoolRoute: state.vanpoolRoute,
    profile: state.profile,
    profileLoaded: state.profile.isLoaded,
    refreshDashboard: state.dashboard.refreshDashboard,
    isTraditionalLead: state.dashboard.isTraditionalLead,
    isRecentLeadSubmitted: state.userAuth.isRecentLeadSubmitted,
    vanpoolStatus: state.userAuth.vanpoolStatus,
    isSubscriptionUser: state.userAuth.isSubscription,
    vanpoolId: state.userAuth.vanpoolId,
    profilePermissionCompleted: state.profile.profilePermissionCompleted,
    userProfile: state.userAuth,
    showEmployerIdPopup: state.dashboard.showEmployerIdPopup,
    employeeInfo: state.profile.employee,
    employeeIdUpdated: state.dashboard.employeeIdUpdated,
    employeeIdUpdatedFailed: state.dashboard.employeeIdUpdatedFailed,
    impactData: state.impactData,
    refreshDashboardAfterContract: state.dashboard.refreshDashboardAfterContract
  };
}

function mapDispatchToProps(dispatch) {
  return {
    init(profileLoaded) {
     // dispatch({ type: actionTypes.AUTHORIZATION_REQUEST});
      dispatch({ type: actionTypes.DASHBOARD_LOADING });
      dispatch({ type: actionTypes.ROUTE_LOADING });
      if(!profileLoaded){
        dispatch({ type: actionTypes.USER_PROFILE_LOADING, notFromProfile:true });
      }
    },
    callTripStatus() {
      if (isAllowed([PERMISSION_VANPOOL_TRIP_RECORDING]) && isAllowed([PERMISSION_TRIP_RECORDING,SUBSCRIPTION_TRIP_RECORDER,PERMISSION_TRADITIONAL_APPROVED_DRIVER_TRIPRECORDER,PERMISSION_COORDINATOR])) {
        dispatch({ type: actionTypes.TRIP_RECORDING_STATUS_LOADING });
      }
      if (isAllowed([PERMISSION_VANPOOL_TRIP_RECORDING]) && !isAllowed([PERMISSION_TRIP_RECORDING,SUBSCRIPTION_TRIP_RECORDER,PERMISSION_TRADITIONAL_APPROVED_DRIVER_TRIPRECORDER,PERMISSION_COORDINATOR])) {
        dispatch({ type: actionTypes.PARTICIPANT_TRIP_STATUS_LOADING });
      }
    },
    setDirections(directions) {
      dispatch({ type: actionTypes.MAP_DIRECTIONS, data: directions });
    },
    fullRefresh() {
      dispatch({ type: actionTypes.REFRESH_DASHBOARD });
    },
    updateLoading(data) {
      dispatch({ type: actionTypes.DASHBOARD_LOADING_PROGRESS, data: data})
    },
    resetProfilePermission() {
      dispatch({ type: actionTypes.PROFILE_PERMISSION_COMPLETED_RESET, data: false})
    },
    updateEmployerId(data, updateEIdFromLogin) {
      dispatch({ type: actionTypes.PERSONAL_INFO_SAVING, data: {...data, updateEIdFromLogin}});
    },
    updateEmployerIdSuccess(data){
      dispatch({ type: actionTypes.EMPLOYERID_UPDATED_SUCCESSFULLY, data: data});
    },
    updateEmployerIdFailure(data) {
      dispatch({ type: actionTypes.EMPLOYERID_UPDATED_FAILURE, data: data});
    },
    updateEmployerIdPopup(data) {
      dispatch({ type: actionTypes.SHOW_EMPLOYER_ID_POPUP, data: data});
    },
    preventHeaderEvents(data) {
      dispatch({ type: actionTypes.PREVENT_HEADER_EVENTS, data: data});
    },
    callUpdatedProfileAPI(){
      dispatch({ type: actionTypes.USER_PROFILE_LOADING, notFromProfile:true });
    },
    fullRefreshAfterContract() {
      dispatch({ type: actionTypes.REFRESH_DASHBOARD_AFTER_CONTRACT })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewDashboard)


